/* eslint-disable no-unused-vars */
import { useCallback, useEffect, useState } from 'react';
import type { ActionDialog } from '../types/dialogs';

type UseActionDialogReturn = {
  actionDialog: ActionDialog;
  dialogBusy: boolean;
  dialogError: string;
  openDialog: (dialog: NonNullable<ActionDialog>) => void;
  closeDialog: () => void;
  setDialogBusy: (busy: boolean) => void;
  setDialogError: (error: string) => void;
  setActionDialog: React.Dispatch<React.SetStateAction<ActionDialog>>;
};

function useActionDialog(): UseActionDialogReturn {
  const [actionDialog, setActionDialog] = useState<ActionDialog>(null);
  const [dialogBusy, setDialogBusy] = useState(false);
  const [dialogError, setDialogError] = useState('');

  // Clear error when dialog kind changes
  useEffect(() => {
    setDialogError('');
  }, [actionDialog?.kind]);

  const openDialog = useCallback((dialog: NonNullable<ActionDialog>) => {
    setActionDialog(dialog);
  }, []);

  const closeDialog = useCallback(() => {
    setActionDialog(null);
    setDialogBusy(false);
    setDialogError('');
  }, []);

  return {
    actionDialog,
    dialogBusy,
    dialogError,
    openDialog,
    closeDialog,
    setDialogBusy,
    setDialogError,
    setActionDialog,
  };
}

export { useActionDialog };
export type { UseActionDialogReturn };
